import React from 'react';

import { useUserInfo } from '../../helpers/hooks/useUserInfo';
import { ProIcon } from '../Icons/ProIcon';

interface IProps {
  isActive: boolean;
  onClick: (state: boolean) => void;
  className?: string;
  testId?: string;
  proOptions?: { proOnly: boolean; proCTA?: () => void };
}

export const ToggleSwitch = ({
  isActive,
  onClick,
  className = '',
  testId = 'toggleSwitch',
  proOptions = { proOnly: false, proCTA: undefined },
}: IProps) => {
  const { isPremium } = useUserInfo();
  const locked = proOptions.proOnly && !isPremium;

  const _onClick = (event: any): void => {
    event.preventDefault();
    event.stopPropagation();
    if (locked && proOptions.proCTA) {
      proOptions.proCTA();
    } else {
      onClick(!isActive);
    }
  };

  return (
    <div className={className}>
      <button
        type="button"
        className={`relative h-6 w-[42px] rounded-[32px] ${
          isActive && !locked ? 'bg-trench' : 'bg-twilight'
        }`}
        onClick={_onClick}
        disabled={locked && !proOptions.proCTA}
        data-testid={testId}
      >
        <div
          className={`absolute top-0.5 size-5 rounded-full bg-sea-foam transition ${
            isActive && !locked ? 'translate-x-full' : 'left-[2px]'
          }`}
        >
          {locked && (
            <ProIcon
              isInverted
              isGreen
              width={13}
              height={13}
              ariaLabel="ProStarIcon"
              dataTestId="ProStar"
            />
          )}
        </div>
      </button>
    </div>
  );
};
